import { Pipe, PipeTransform } from '@angular/core';
import { CustomTableColumnDefinition } from './table.component';

@Pipe({
  name: 'iconColor',
  pure: true,
})
export class IconColorPipe implements PipeTransform {
  /**
   * Returns the icon color for a table column
   * @param column The table column definition
   * @returns The icon color string value
   */
  transform(column: CustomTableColumnDefinition): string {
    const defaultIconColor = '#66B4E3';
    return column.iconColor ? column.iconColor : defaultIconColor;
  }
}
